// extracted by mini-css-extract-plugin
module.exports = {"landingHero":"hero_landingHero__F6eIX","subtitleTextAccent":"hero_subtitleTextAccent__E0vft"};